<template>
  <div class="hello">
    <header>
      <h1>Remo复古相机-VIP服务协议</h1>
      <p>最近更新日期：【2024】年【4】月【25】日。</p>
    </header>
    <section>
      <h2>1.服务条款的确认和接受</h2>
      <ul>
        <li>1.1本协议是VIP用户与重庆盛纳科技有限公司（下称“Remo复古相机”）之间关于用户成为Remo复古相机VIP用户且使用Remo复古相机提供的VIP服务所订立的协议。本协议描述Remo复古相机与VIP用户之间关于软件许可以及服务使用及相关方面的权利义务。“VIP用户”是指享受Remo复古相机提供的VIP服务的个人或单一实体。本服务协议构成您（无论个人或者单位）使用Remo复古相机所提供的VIP服务之先决条件，除非您接受本协议条款，否则您无权使用本协议的相关服务。您的使用行为将视为同意接受本协议各项条款的约束。</li>
        <li><b>1.2请您审阅并接受或不接受本协议，未成年人应在法定监护人陪同下审阅和履行，未成年人行使和履行本协议项下的权利和义务视为已获得了法定监护人的认可，您在享受Remo复古相机VIP用户服务时必须完全、严格遵守本服务协议条款。</b></li>
      </ul>
      <h2>2.服务说明</h2>
      <ul>
        <li><b>2.1 VIP服务并非存款、预付款或其他可无理由退还性质的商品或财产权利，VIP服务提供的商品根据《消费者权益保护法》属于在线拆封交付的数字化商品，因其特殊属性不适用《消费者权益保护法》中有关反悔权及网络购买商品七日无理由退货等条款的约束，VIP购买成功，商品即完成在线交付，一经购买，本平台不提供任何退还服务。除法律法规明确要求以外或因Remo复古相机产品技术原因，导致您购买时被重复扣款或无法享有购买的服务时（Remo复古相机只兼容手机端，不兼容其他设备，如:平板、PC、模拟器等，开通VIP前请仔细确认所使用设备是否为手机端，若因其他设备不兼容导致Remo复古相机无法正常使用概不退款），您可提出退款申请。提出退款申请时，需要您提供相应信息，经Remo复古相机核实后方可为您办理退款。您理解并清楚接受上述条件，如您不接受，请谨慎选择此服务。</b></li>
        <li>2.2在购买Remo复古相机VIP服务时，用户必须仔细确认自己的账号及需要购买的VIP类型，若因用户自身操作不当或不了解服务计费方式等因素造成充错账号、错选服务类型等情形而损害自身权益的，不得因此要求Remo复古相机作任何补偿或赔偿。</li>
        <li>2.3Remo复古相机VIP用户服务涉及的Remo复古相机产品所有权以及相关软件知识产权归Remo复古相机所有。Remo复古相机所提供的服务将按照其服务条款和操作规则严格执行。VIP用户在享受Remo复古相机任何单项服务时，应当受本协议以及《Remo复古相机用户协议》的约束。</li>
        <li>2.4Remo复古相机享有对VIP用户网上一切活动的监督、提示、检查的权利，如VIP用户的行为违反有关法律法规或违反本协议条款的约定，Remo复古相机享有要求其纠正及追究其责任等权利。</li>
        <li>2.5Remo复古相机向VIP用户提供的全部服务，均仅限于VIP用户在Remo复古相机平台使用，任何以恶意破解等非法手段将Remo复古相机提供的服务内容与Remo复古相机平台分离的行为，均不属于本协议中约定的Remo复古相机提供的服务。由此引起的一切法律后果由行为人负责，Remo复古相机将依法追究行为人的法律责任。</li>
        <li>2.6当VIP用户使用Remo复古相机各单项服务时，VIP用户的使用行为视为其对各单项服务的服务条款以及Remo复古相机在该单项服务中发出各类公告的同意。</li>
        <li>2.7您明确了解并同意，Remo复古相机VIP用户的付费方式为代收费运营商托收的付款方式，您通过此种付费方式付费可能存在一定的商业风险，包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动，该等风险均会给您造成相应的经济损失。您应自行承担向侵权方追究侵权责任和追究责任不能的后果。</li>
        <li>2.8您应自行负责妥善且正确地保管、使用、维护您在Remo复古相机申请取得的账户、账户信息。您应对您账户信息采取必要和有效的保密措施。非Remo复古相机原因致使您账户泄漏以及因您保管、使用、维护不当造成损失的，Remo复古相机无须承担与此有关的任何责任。</li>
        <li>2.9Remo复古相机不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务和网络接入服务、任意第三方的侵权行为。</li>
        <li>2.10VIP服务使用期限包含Remo复古相机解决故障、服务器维修、调整、升级等所需用的合理时间，对上述情况所需用的时间Remo复古相机不予补偿并保留解释权。</li>
        <li>2.11VIP用户在使用Remo复古相机所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，Remo复古相机均不负责任。</li>
        <li>2.12由于VIP用户将账户信息告知他人或与他人共享注册账户，由此导致的任何个人资料泄露，Remo复古相机不负任何责任。</li>
      </ul>
      <h2>3.成为VIP用户的程序</h2>
      <ul>
        <li>3.1在成为Remo复古相机VIP用户之前，您必须先注册成为Remo复古相机用户。用户所填写的内容与个人资料必须真实有效，否则Remo复古相机有权拒绝其申请或撤销其VIP用户资格，并不予任何赔偿或退还VIP用户服务费。</li>
        <li>3.2用户可通过各种已有和未来新增的渠道成为Remo复古相机VIP用户，包括但不限于：通过手机支付或第三方支付等方式成为VIP用户。在用户使用具体某种方式成为VIP用户时，须阅读并确认接受相关的服务条款和使用方法。Remo复古相机在此声明：Remo复古相机从未授权任何第三方单位或个人销售、转让Remo复古相机VIP用户资格，任何未经授权销售Remo复古相机VIP用户的属于非法销售，Remo复古相机有权追究其法律责任。</li>
        <li>3.3成为VIP用户后，VIP用户有权利不接受Remo复古相机的服务，可申请取消VIP用户服务，但不获得VIP用户服务费的退还。</li>
        <li>3.4Remo复古相机VIP用户账号所有权归Remo复古相机所有，VIP用户拥有Remo复古相机账号的有限使用权。</li>
        <li>3.5Remo复古相机仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由VIP用户自行负担。</li>
      </ul>
      <h2>4. VIP用户服务和账号查询</h2>
      <ul>
        <li>4.1 一旦您成为Remo复古相机VIP用户，即视为您认可该项服务标明之价格；成为Remo复古相机VIP用户后，该项服务即时生效。</li>
        <li>4.2 VIP用户的增值服务资费标准以Remo复古相机网站上标注的详细资费标价为准，Remo复古相机有权基于自身业务发展需要变更上述资费标准，具体政策以Remo复古相机在相关服务页面公告的内容为准。</li>
        <li>4.3您可以通过登录Remo复古相机VIP用户中心免费查询您的账号信息详情，包括已开通的服务内容、服务期限等。</li>
      </ul>
      <h2>5. VIP用户权限及服务期限</h2>
      <p>您在购买Remo复古相机VIP用户后可享受的全部权益以Remo复古相机App公布的权益为准，Remo复古相机有权基于Remo复古相机自身业务发展需要变更全部或部分权益。就前述权益调整Remo复古相机将在相应服务页面进行通知或公告，您也可通过Remo复古相机App查询最新的权益内容。</p>
      <h2>6. VIP用户的权利及限制</h2>
      <ul>
        <li>6.1在VIP用户有效期内，VIP用户可优先参加由Remo复古相机组织的活动并享有由Remo复古相机提供的各项优惠及增值服务。</li>
        <li>6.2 VIP用户服务仅限于申请账号自行使用；VIP用户服务期内不能在Remo复古相机账户号之间转移，禁止赠与、借用、作用、转让或售卖。否则Remo复古相机有权在未经通知的情况下取消转让账户、受让账户的VIP用户服务资格，由此带来的损失由VIP用户自行承担。</li>
        <li>6.3若VIP用户的行为持续违反本协议或违反国家相关法律法规，或Remo复古相机认为VIP用户行为有损Remo复古相机或他人的声誉及利益，Remo复古相机有权取消该VIP用户的VIP用户资格而无须给与任何补偿。</li>
        <li>6.4 VIP用户不得以盗窃、利用系统漏洞等非法途径以及在未获Remo复古相机授权的非法销售Remo复古相机VIP用户的网站上获取或购买VIP用户服务，否则Remo复古相机有权取消VIP用户的服务资格。由此引发的问题由VIP用户自行承担，Remo复古相机不负任何责任。</li>
        <li>6.5任何VIP用户不得使用带有非法、淫秽、污辱或人身攻击的含义污辱或人身攻击的昵称，一经发现，Remo复古相机有权取消其VIP用户资格而无需给与任何补偿和退费。</li>
        <li>6.6被取消VIP用户资格的VIP用户，不能再参加由Remo复古相机组织的活动并不可再享有由Remo复古相机提供的各项优惠及增值服务，即不再享有VIP用户权利。</li>
      </ul>
      <h2>7.协议的变更</h2>
      <ul>
        <li>7.1Remo复古相机有权根据互联网的发展和中华人民共和国有关法律、法规的变化，不断完善服务质量并随时修改服务条款，修改内容一经公布立即生效，无需另行单独通知VIP用户。VIP用户的权利以及义务的表述、购买程序、收费标准，均以最新的服务条款为准。</li>
        <li>7.2如果VIP用户不同意Remo复古相机的变更，可主动向Remo复古相机提出终止VIP用户服务，Remo复古相机有权不予退还用户已支付的VIP服务费用。但用户已经付费取得的服务内容、服务时长等，可以在原有范围内使用。如果VIP用户继续享用VIP用户服务，则视为VIP用户已经接受条款的修改。</li>
      </ul>
      <h2>8.服务的中断和终止</h2>
      <ul>
        <li>8.1因发生Remo复古相机不可抗拒的事由，如政府行为、不可抗力，导致VIP用户服务无法继续，Remo复古相机会以最快的速度通知VIP用户，但不承担由此对VIP用户造成的任何损失并不退还VIP用户服务费。</li>
        <li>8.2如VIP用户违反或被视为违反本服务条款中的内容，Remo复古相机有权在不通知VIP用户的情况下立即终止您已购买的所有服务，以及取消您的Remo复古相机VIP用户账户和使用权限，但不退还任何已缴纳的VIP用户服务费用。</li>
        <li>8.3因您的Remo复古相机账号注销、失效、丢失、被封停导致本平台无法提供VIP服务时，由您自行负责，本平台不承担责任。</li>
        <li>8.4Remo复古相机未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。Remo复古相机随时有权要求您继续履行义务并承担相应的违约责任。</li>
      </ul>
      <h2>9.法律的适用和管辖</h2>
      <ul>
        <li>9.1本服务条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本服务条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</li>
        <li>9.2如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，任何一方均可向被告住所地法院提起诉讼。</li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: 12px
}

h1 {
  font-size: 18px;
  margin: 10px 0;
}

h2 {
  margin: 10px 0;
  font-size: 14px
}


li {
  margin: 10px 0;
  list-style: none;
}


p {
  margin: 10px 0;
}

.tab {
  table-layout: fixed;
  text-align: left;
  width: 100%;
  border-collapse: collapse;
}

.tab tr {
  width: 100%;
}

.tab th {
  padding: 0 4px;
}

.tab td {
  width: 25%;
  padding: 0 4px;
  word-break: break-all;
}

.link {
  word-wrap: break-word;
}
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue